export default "__VITE_ASSET__CfhW1EBY__"